import { useContext, useState } from "react"
import { useAlert } from "react-alert"
import Axios from "../../../../../Axios"
import Config from "../../../../../Config"
import AppContext from "../../../../partials/AppContext"
import SuccessAlert from "../../../../Shared/SuccessAlert"

const Accept = ({cancel ,id ,name ,reload}) => {
    const alert = useAlert()
    const {clearUserData ,userToken} = useContext(AppContext)
    const [disabled ,setDisabled] = useState(false)
    const entityUrl = `${Config.apiBaseUrl}/gym-membership/member-request-gym`

    const confirm = () => {
        setDisabled(true)
        Axios
        .setAuthToken(userToken)
        .put(`${entityUrl}/accept/${id}`)
        .then(response => {
            setDisabled(false)
            alert.success(response?.data?.message)
            cancel()
            reload()
        })
        .catch(err => {
            setDisabled(false)
            const error = {...err}
            if (error?.response?.data?.message) alert.error(error?.response?.data?.message)
            if (error?.response?.status === 401) clearUserData()
        })
    }

    return (
        <div id="forms">
            <SuccessAlert
                disabled={disabled}
                heading={`Accept "${name}"`}
                message={`Are you sure you want to accept this gym "${name}" ? Make sure to receive the payment in cash ,after subscribe him from Free`}
                confirmLabel="Yes Accept"
                confirm={confirm}
                cancel={cancel}
            />
        </div>
    )
}

export default Accept